import { render, staticRenderFns } from "./ExpressPackage.vue?vue&type=template&id=59540988&scoped=true"
import script from "./ExpressPackage.vue?vue&type=script&lang=js"
export * from "./ExpressPackage.vue?vue&type=script&lang=js"
import style0 from "./ExpressPackage.vue?vue&type=style&index=0&id=59540988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59540988",
  null
  
)

export default component.exports